import { render, staticRenderFns } from "./ManageAdministrators.vue?vue&type=template&id=e620830a&scoped=true&"
import script from "./ManageAdministrators.vue?vue&type=script&lang=js&"
export * from "./ManageAdministrators.vue?vue&type=script&lang=js&"
import style0 from "./ManageAdministrators.vue?vue&type=style&index=0&id=e620830a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e620830a",
  null
  
)

export default component.exports